import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_STAFF_DETAILS } from "../../../apis/organization-apis/people-apis/peopleApis";
import Role from "../../../utils/roles";

export const getEmployeeEmail = (emp) =>
  emp?.work_email ||
  emp?.emails?.find((em) => em.is_primary)?.email ||
  emp?.emails?.find((em) => em.type === "work")?.email ||
  emp?.emails?.[0]?.email ||
  "";

export const getEmployeeName = (emp) =>
  emp?.name || `${emp?.first_name || ""} ${emp?.last_name || ""}`.trim();

export const mapStaffOptions = (employees = []) =>
  employees
    .filter((emp) =>
      emp.roles?.some(
        (role) => role?.role_description?.toLowerCase() === Role.ADMIN.toLowerCase()
      )
    )
    .map((emp) => ({
      email: getEmployeeEmail(emp),
      name: getEmployeeName(emp),
    }))
    .filter((person) => person.email);

export const getOwnerLabel = (people = [], email) => {
  if (!email) return "Unassigned";
  const match = people.find((p) => p.email === email);
  return match?.name || email;
};

const useVendorStaff = () => {
  const { data, loading } = useQuery(GET_STAFF_DETAILS);

  const people = useMemo(
    () => mapStaffOptions(data?.getEmployees?.data || []),
    [data]
  );

  return { people, loading };
};

export default useVendorStaff;
